import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import Sortable from 'sortablejs';
import { SidebarService } from '../navbar/sidebar.service';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ModalFacturasPendientesComponent } from './modal-facturas-pendientes.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild(ModalFacturasPendientesComponent)
  modalFacturas!: ModalFacturasPendientesComponent;

  mensajeCambiosNuevos = true;
  nuevosCambiosExpandido = false;
  planes: any[] = [];

  constructor(
    private sidebarSrv: SidebarService,
    private apiSrv: ApiService,
    private loadingSrv: LoadingService
  ) {}
  ngOnInit(): void {
    // Activar loading inmediatamente para verificación de estado de pago
    this.apiSrv.obtenerPlanesActivos().subscribe((data) => {
      this.planes = data;
    });

    // Verificar estado de pago al inicializar el componente
    this.verificarEstadoPago();
  }

  ngAfterViewInit() {
    const cardsContainer = document.getElementById('cards-container');
    if (cardsContainer) {
      Sortable.create(cardsContainer, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        onEnd: () => this.saveOrder(),
      });
    }

    this.restoreOrder();
  }

  saveOrder() {
    const cardsContainer = document.getElementById('cards-container');
    if (cardsContainer) {
      const order = Array.from(cardsContainer.children).map(
        (child) => child.id
      );
      localStorage.setItem('cardsOrder', JSON.stringify(order));
    }
  }

  restoreOrder() {
    const cardsContainer = document.getElementById('cards-container');
    const order: string[] = JSON.parse(
      localStorage.getItem('cardsOrder') || '[]'
    );

    if (cardsContainer && order.length > 0) {
      const fragment = document.createDocumentFragment();
      order.forEach((id: string) => {
        const element = document.getElementById(id);
        if (element) {
          fragment.appendChild(element);
        }
      });
      cardsContainer.appendChild(fragment);
    }
  }

  abrirVentanaReporte() {
    this.sidebarSrv.cambiarEstadoDeVentana('reporteTitularesSinDj', true);
  }

  toggleNuevosCambios(): void {
    this.nuevosCambiosExpandido = !this.nuevosCambiosExpandido;
  }

  private verificarEstadoPago(): void {
    this.apiSrv.consultarEstadoPago().subscribe({
      next: (respuesta) => {
        if (respuesta.esDeudor) {
          this.mostrarModalFacturasPendientes();
        } else {
          // Si está pago, quitar el loading
          this.loadingSrv.setLoading(false);
        }
      },
      error: (error) => {
        // En caso de error, no mostrar el modal por defecto y quitar loading
        this.loadingSrv.setLoading(false);
      },
    });
  }

  private mostrarModalFacturasPendientes(): void {
    if (this.modalFacturas) {
      this.modalFacturas.mostrarModal();
      // Quitar el loading solo cuando se muestra el modal
      this.loadingSrv.setLoading(false);
    }
  }
}
